/* @flow */
import { IO } from 'trustar/fp';
import favicon from 'trustar/img/favicon.ico';
import createDebugger from 'debug';
import qs from "querystring";
const debug = createDebugger('app:components:AppUtils'); // eslint-disable-line no-unused-vars

/**
 * This was to counter an issue we saw in firefox. See 3d4775e for full
 * details.
 */
export const resetFavicon = () =>
  IO(() => document.getElementById('favicon'))
    .map(el => {
      const link = el.cloneNode(true);
      link.href = favicon;
      return link;
    })
    // $FlowIgnore: This is IO so it doesn't matter if this throws
    .map(link => document.head.appendChild(link))
    .fold(debug, () => debug('Favicon reset'));

/**
 * Fetches a current URL's query params
 * @returns {*}
 */
export const getBrowserQueryParams = () => qs.parse(location.search.replace(/^\?/, ''));


// WEBPACK FOOTER //
// ./src/app/modules/app/utils.js